import type {
  OtpSmsConfirmMutation,
  OtpSmsConfirmParams,
  OtpSmsSendMutation,
  OtpSmsSendParams,
} from '@/generated/hasura';
import { otpSmsConfirm, otpSmsSend } from '@/graphql/hasura/auth/otp-sms';
import { initializeApollo } from '@/lib/apollo/apollo-client';
import { AlterError } from '@/lib/error';

const context = { clientName: 'rapptr' };

export const sendOtpSms = async (otpSmsSendParams: OtpSmsSendParams): Promise<void> => {
  const apolloClient = initializeApollo();
  const { data } = await apolloClient.mutate<OtpSmsSendMutation>({
    mutation: otpSmsSend,
    context,
    variables: {
      otpSmsSendParams,
    },
  });
  if (data?.otpSmsSend?.alterError) {
    throw new AlterError(data.otpSmsSend.alterError);
  }
};

export type ConfirmOtpSmsTokenSet = NonNullable<
  NonNullable<OtpSmsConfirmMutation['otpSmsConfirm']>['tokenSet']
>;

export const confirmOtpSms = async (
  otpSmsConfirmParams: OtpSmsConfirmParams
): Promise<ConfirmOtpSmsTokenSet> => {
  const apolloClient = initializeApollo();
  const { data } = await apolloClient.mutate<OtpSmsConfirmMutation>({
    mutation: otpSmsConfirm,
    context,
    variables: {
      otpSmsConfirmParams,
    },
  });
  if (data?.otpSmsConfirm?.alterError) {
    throw new AlterError(data.otpSmsConfirm.alterError);
  }
  const tokenSet = data?.otpSmsConfirm?.tokenSet;
  if (!tokenSet) {
    throw new Error('TOKEN_SET_NOT_DEFINED');
  }
  return tokenSet;
};
